import { UntypedFormControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { Directive } from '@angular/core';

@Directive({
  selector: '[PdfValidator]',
  providers: [
    {
      provide: NG_VALIDATORS, useExisting: PdfValidator, multi: true
    }
  ]
})

export class PdfValidator implements Validator {

  public static validate(formControl: UntypedFormControl): any {

    if (formControl.value) {
      return PdfValidator.checkExtension(formControl);
    }
  }

  public static checkExtension(formControl: UntypedFormControl) {
    let valToLower = formControl.value.name.toLowerCase();
    let regex = new RegExp("(.*?)\.(pdf)$"); //add or remove required extensions here
    let regexTest = regex.test(valToLower);
    return !regexTest ? { "notSupportedPdf": true } : null;

  }

  validate(formControl: UntypedFormControl): { [key: string]: any } {
    return PdfValidator.validate(formControl);
  }

}